export default __webpack_public_path__ + "static/media/compas_project_formation_options.b1e4e936.gif";